import { render, staticRenderFns } from "./job_settings.vue?vue&type=template&id=5cbb8427&scoped=true"
import script from "./job_settings.vue?vue&type=script&lang=js"
export * from "./job_settings.vue?vue&type=script&lang=js"
import style0 from "./job_settings.vue?vue&type=style&index=0&id=5cbb8427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb8427",
  null
  
)

export default component.exports